module.exports = __webpack_public_path__ + "img/lawrence.d421e293.png";